import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../components/Footer'
import img from '../Img/img.png'
import rectangle from '../Img/Rectangle.png'

function Ask() {
  return (
    <div>
        <div className='m-4 flex justify-center'>
        <h1 className='font-bold text-lg'>Ask</h1>
      </div>
      <div>
        <div className='flex justify-evenly w-full'>
            <div className='w-full  flex flex-col justify-center items-center cursor-pointer   '>
            <Link to='/ask' className='mx-auto font-bold'>Poll</Link>
            <hr className='w-full mt-3 border-t-2 border-black'/>
            </div>
            <div className='w-full  flex flex-col justify-center items-center cursor-pointer'>
            <Link to='/askquestion'>Question</Link>
            <hr className='w-full mt-3 border-t-2'/>
            </div>
            
        </div>
        <div className='h-[320px] w-[325px] bg-[#d3f36b]/50 m-[24px] rounded-lg'>
            <div className='flex justify-between'>
            <div className='flex ml-5 pt-5'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Yoga</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col mr-4 pt-4'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          
        </div>
            </div>
        <p className='p-4'>Lorem ipsum dolor sit amet consectetur. Ut cursus adipiscing dolor velit</p>
        <div className='flex justify-between px-4 mb-4'>
            <p className='text-gray-500 text-[15px]'>Some Answers</p>
            <img className='w-[15px] h-[15px] mt-1' src={rectangle} alt="" />
        </div>
        <div className='flex justify-between px-4 mb-4'>
            <p className='text-gray-500 text-[15px]'>Some Answers</p>
            <img className='w-[15px] h-[15px] mt-1' src={rectangle} alt="" />
        </div>
        <div className='flex justify-between px-4 mb-4'>
            <p className='text-gray-500 text-[15px]'>Some Answers</p>
            <img className='w-[15px] h-[15px] mt-1' src={rectangle} alt="" />
        </div>
        <div className='flex justify-between px-4'>
            <p className='text-gray-500 text-[15px]'>Some Answers</p>
            <img className='w-[15px] h-[15px] mt-1' src={rectangle} alt="" />
        </div>
            </div>
      </div>
      <div className='h-[320px] w-[325px] bg-[#d3f36b]/50 m-[24px] rounded-lg'>
            <div className='flex justify-between'>
            <div className='flex ml-5 pt-5'>
           <img src={img} alt="" /> 
          <div className='ml-3'>
          <h3 className='font-bold'>Yoga</h3>
          <p className='text-sm text-gray-500'>I'm available to connect live</p>
          </div>
        </div>
        <div className='flex flex-col mr-4 pt-4'>
            <p className='text-gray-500 text-sm'>5.08pm</p>
          
        </div>
            </div>
        <p className='p-4'>Lorem ipsum dolor sit amet consectetur. Ut cursus adipiscing dolor velit</p>
        <div className='flex justify-between px-4 mb-4'>
            <p className='text-gray-500 text-[15px]'>Some Answers</p>
            <img className='w-[15px] h-[15px] mt-1' src={rectangle} alt="" />
        </div>
        <div className='flex justify-between px-4 mb-4'>
            <p className='text-gray-500 text-[15px]'>Some Answers</p>
            <img className='w-[15px] h-[15px] mt-1' src={rectangle} alt="" />
        </div>
        <div className='flex justify-between px-4 mb-4'>
            <p className='text-gray-500 text-[15px]'>Some Answers</p>
            <img className='w-[15px] h-[15px] mt-1' src={rectangle} alt="" />
        </div>
        <div className='flex justify-between px-4'>
            <p className='text-gray-500 text-[15px]'>Some Answers</p>
            <img className='w-[15px] h-[15px] mt-1' src={rectangle} alt="" />
        </div>
            </div>
      <Footer />
    </div>
  )
}

export default Ask